var translations = {
    de: {
        title: 'Bau-/Immobilienfinanzierung kostenlos und unverbindlich anfragen',
        numberOfApplicants: 'Anzahl Darlehensnehmer',
        oneApplicant: 'eine Person',
        twoApplicants: 'zwei Personen',
        numberOfApplicantsDescription: "Geben Sie hier die Anzahl der Kreditnehmer ein.\nBeachten Sie, dass die Bonit\u00E4t und somit die Annahmewahrscheinlichkeit bei weiteren Kreditnehmern steigen kann.",
        applicant: 'Kreditnehmer',
        secondApplicantQuestion: 'Lebt die Person im selben Haushalt?',
        yes: 'Ja',
        no: 'Nein',
        maritalStatusLabel: 'Verhältnis zum ersten Darlehensnehmer',
        maritalStatus_married: 'Verheiratet',
        maritalStatus_partnership: 'Lebenspartnerschaft',
        maritalStatus_separated: 'Getrennt lebend',
        maritalStatus_divorced: 'Geschieden',
        maritalStatus_no_value: 'Sonstiges',
        // @todo [need-task] need tokenizer
        policiesDescriptionHTML: 'Mit Klick auf den “Weiter”-Button akzeptiere ich die <a href="https://legal-docs.smava.de/mortgageTerms.pdf" target="_blank">AGB</a> und erteile smava einen kostenlosen Kreditvergleichs- und Vermittlungsauftrag. Ich habe die <a href="https://legal-docs.smava.de/mortgageMandatoryInfo.pdf" target="_blank">Pflichtinformationen</a> und die <a href="https://legal-docs.smava.de/mortgagePrivacyNotice.pdf" target="_blank">Datenschutzhinweise</a> hiermit erhalten.',
        subscriptionPoliciesText: 'Sie erhalten Informationen und Umfragen zu unserer Dienstleistung unter Verwendung elektronischer Post. Dem Erhalt können Sie jederzeit per E-Mail an info@smava.de widersprechen.',
        submit: 'Weiter',
        submitDescription: 'kostenlos und unverbindlich',
    },
};
export default translations;
